
import { useEffect } from 'react';

type SearchShortcutProps = {
  onActivate: () => void;
  isActive?: boolean;
};

export const useSearchShortcut = ({ onActivate, isActive = false }: SearchShortcutProps) => {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Check if the focus is on an input or textarea
      const activeElement = document.activeElement;
      const isInputActive = activeElement instanceof HTMLInputElement || 
                           activeElement instanceof HTMLTextAreaElement;
      
      // Only trigger if not already active and not focused on an input
      if ((e.key === 'k' && (e.metaKey || e.ctrlKey)) && !isActive && !isInputActive) {
        e.preventDefault();
        onActivate();
      }
      
      // ESC key can be handled elsewhere to close the search
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onActivate, isActive]);
};

export default useSearchShortcut;
